package com.milta.core.localization.translations.sq

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Anulo",
    confirm = "Konfirmo",
    save = "Ruaj",
    delete = "Fshi",
    back = "Kthehu",
    loading = "Duke ngarkuar…",
    retry = "Provo përsëri",
    creationInProgressDoNotClose = "Krijimi në vazhdim, mos e mbyllni dritaren",
    processingStepSent = "Dokumenti u dërgua",
    processingStepReading = "Leximi i dokumentit",
    processingStepFinding = "Gjetja e dërgesave",
    processingStepChecking = "Verifikimi i adresave",
    processingUsualDuration = "Zakonisht 20 deri në 40 sekonda. Qëndroni në këtë ekran, ne kujdesemi për pjesën tjetër.",
    processingLongWait = "Dokumenti juaj përmban shumë informacion, analiza po zgjat pak më shumë se zakonisht. Gjithçka funksionon, po vazhdojmë.",
    processingInProgressSince = "Në vazhdim prej %1",
    processingFinishedIn = "Përfundoi në %1",
    processingDeliveriesFound = "U gjetën %1 dërgesa",
    processingDeliveriesFoundOne = "U gjet 1 dërgesë",
    processingAddressesChecked = "%1 nga %2 adresa",
    addressVerifiedBadge = "✓ Adresa u verifikua",
    addressNeedsReviewBadge = "⚠ Adresa duhet verifikuar",
    addressFoundLine = "U gjet: %1",
    language = "Gjuha",
    welcomeTitle = "Mirë se vini në Milta",
    welcomeSubtitle = "Asistenti juaj i zgjuar i dorëzimit",
    alreadyHaveAccount = "Kam tashmë një llogari",
    createAccount = "Krijo një llogari",
    continueWithGoogle = "Vazhdo me Google",
    continueWithApple = "Vazhdo me Apple",
    oauthErrorGeneric = "Ndodhi një gabim gjatë hyrjes. Ju lutemi provoni përsëri.",
    oauthAppleWebComingSoon = "Hyrja me Apple do të jetë e disponueshme së shpejti në ueb.",
    oauthDriverAccountNotAllowedOnWeb = "Llogaritë e shoferëve nuk mund të hyjnë në panelin e uebit. Identifikohuni nga aplikacioni celular.",
    oauthAccountNotFoundOnWeb = "Nuk u gjet asnjë llogari Milta për këtë llogari Google.",
    errorOffline = "Nuk ka lidhje interneti.",
    navTourneesDuJour = "Turet e sotme",
    navAjouterUneTournee = "Shto një turne",
    navHistoriqueDesPreuves = "Historiku i dorëzimeve",
    navParametres = "Cilësimet",
    sidebarRoleManagerLabel = "Menaxher",
    noDeliveriesYetTitle = "Ende asnjë dorëzim",
    noDeliveriesYetSubtitle = "Prekni „Shto dorëzime” për të shtuar",
    optimizationUnavailableExplanation = "Dëshironi ta krijoni turin pa optimizim, apo të provoni sërish?",
    createWithoutOptimizationAction = "Krijo pa optimizim",
    gpsAppSheetTitle = "Zgjidh një aplikacion navigimi",
    addressSearchingLabel = "Duke kërkuar…",
    clearTimeFieldAction = "Pastro",
    clearTimeFieldConfirmTitle = "Të pastrohet ora?",
    clearTimeFieldConfirmMessage = "Ora aktuale do të hiqet. Mund të caktoni një të re në çdo kohë.",
    updateRequiredTitle = "Përditësim i detyrueshëm",
    updateRequiredMessage = "Është i disponueshëm një version i ri i Milta. Përditësoni aplikacionin për ta përdorur më tej.",
    updateInstalledVersionLabel = "I instaluar",
    updateAvailableVersionLabel = "I disponueshëm",
    updateNowButton = "Përditëso",
    updateDataKeptNote = "Rrugët dhe dorëzimet tuaja ruhen.",
    updateSendingPendingOne = "Po dërgohet 1 dorëzim i vërtetuar jashtë linje…",
    updateSendingPendingMany = "Po dërgohen {count} dorëzime të vërtetuara jashtë linje…",
)
